import { DesktopSettings } from '@honestica/electron-bridge-typing';
import { defaultDesktopSettings } from '@launcher/utils/desktop/settings/defaultSettings.utils';

export const initialState: DesktopState = {
  immutableSettings: [],
  loadingSettings: true,
  settings: defaultDesktopSettings,
  watchingFolders: false,
  desktopFeaturesInitialized: false,
};

export interface DesktopState {
  immutableSettings: (keyof DesktopSettings)[];
  loadingSettings: boolean;
  settings: DesktopSettings;
  watchingFolders: boolean;
  desktopFeaturesInitialized: boolean;
}
